import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError("");
    try { await login(email, password); nav("/admin"); }
    catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-[70vh] grid place-items-center px-4 py-16" data-testid="admin-login-page">
      <Seo title="Admin sign in" noindex />
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-[#E2E8F0] bg-white p-8 shadow-xl space-y-5" data-testid="admin-login-form">
        <div className="h-12 w-12 rounded-full bg-[#E6F4F1] grid place-items-center"><Lock className="h-5 w-5 text-[#027A6D]" /></div>
        <h1 className="text-2xl font-bold text-[#0B2150]">Admin sign in</h1>
        <div className="space-y-1.5"><Label htmlFor="a-email">Email</Label><Input id="a-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" /></div>
        <div className="space-y-1.5"><Label htmlFor="a-pass">Password</Label><Input id="a-pass" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" /></div>
        {error && <p role="alert" className="text-sm text-red-700" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy} className="w-full rounded-full bg-[#0B2150] text-white py-2.5 font-semibold hover:bg-[#03A896] disabled:opacity-60" data-testid="admin-login-submit">{busy ? "Signing in…" : "Sign in"}</button>
      </form>
    </div>
  );
}
